import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="file-drop"
// メッセージ添付エリアへのドラッグ&ドロップを担う。ドロップされたファイルの保持・検証は
// selected-attachments コントローラーに委譲する（本体はハイライト表示のみ）。
export default class extends Controller {
  static classes = ["dragover"]
  static outlets = ["selected-attachments"]

  connect() {
    // ドラッグの出入りカウンター（子要素をまたいでもちらつかないように）
    this.dragDepth = 0
  }

  // ドラッグ対象がファイルかどうか（テキスト等のドラッグでは反応しない）
  isFileDrag(event) {
    return Array.from(event.dataTransfer?.types ?? []).includes("Files")
  }

  // 添付不可（送信中）かどうか。詳細は selected-attachments#disabled 参照
  get disabled() {
    return !this.hasSelectedAttachmentsOutlet || this.selectedAttachmentsOutlet.disabled
  }

  dragEnter(event) {
    if (!this.isFileDrag(event)) return
    event.preventDefault() // disabled でもブラウザ既定動作（ファイルを開く遷移）を抑止する
    if (this.disabled) return // 添付不可ならハイライトはしない
    this.dragDepth++
    this.element.classList.add(this.dragoverClass)
  }

  dragOver(event) {
    if (!this.isFileDrag(event)) return
    event.preventDefault()
  }

  dragLeave(event) {
    if (!this.isFileDrag(event) || this.disabled) return
    this.dragDepth--
    if (this.dragDepth <= 0) {
      this.dragDepth = 0
      this.element.classList.remove(this.dragoverClass)
    }
  }

  drop(event) {
    if (!this.isFileDrag(event)) return
    event.preventDefault() // disabled でもブラウザ既定動作（ファイルを開く遷移）を抑止する
    this.dragDepth = 0
    this.element.classList.remove(this.dragoverClass)
    if (this.disabled) return // 添付不可ならアップロードしない

    const files = Array.from(event.dataTransfer?.files ?? [])
    if (files.length > 0) this.selectedAttachmentsOutlet.add(files)
  }
}
